import script from "./zoom-image.vue?vue&type=script&setup=true&lang=js"
export * from "./zoom-image.vue?vue&type=script&setup=true&lang=js"

import "./zoom-image.vue?vue&type=style&index=0&id=5ebe6399&lang=css"

const __exports__ = script;

export default __exports__